<div class="content vertical-as" #content>
  <div class="header" *ngIf="showHeader">
    <h2
      [class.is-search-page]="isSearchPage"
      [style]="'fontSize.28' | translate"
    >
      {{ header }}
    </h2>
  </div>

  <div
    class="items-wrapper grid-container"
    [ngClass]="{ 'set-margin': setMargin }"
    #itemsWrapper
  >
    <div
      *ngFor="
        let row of gridRows;
        let verticalIndex = index;
        trackBy: trackByIndex
      "
      class="row horizontal-ac grid-container-row"
      [ngClass]="'vertical-carousel-row-' + verticalIndex"
      [style.margin-bottom]="verticalIndex === gridRows.length - 1 ? '4.167vw' : '1.563vw'"

      #row
    >
      <ng-container *ngFor="let item of row; let horizontalIndex = index; trackBy: trackByIndex">
        <div
          class="cards-container focusable-element"
          tabindex="0"
          [style.width]="sectionWidth"
          (focus)="onFocus(item,verticalIndex,horizontalIndex)"
          (focusout)="clearFocusCardDebounceTimer()"
          (click)="onClick(item)"
          id="card-identifier"
          (keydown)="onKeyDown($event, verticalIndex, horizontalIndex)"
        >
          <div class="image-container vertical-ac">
            <div
              class="image-wrapper vertical-as"
              [ngClass]="getClassNames()"
              [style.width]="cardWidth"
              [style.height]="cardHeight"
              [style.--card-width]="cardWidth"
              [style.margin]="'$vh-3 $vw-3'"
            >
              <img
                [src]="item?.image"
                alt="Card Image"
                class="card-image"
                (error)="onImageError($event)"
                loading="lazy"
                (load)="onImageLoad()"
                [class.loaded]="imageLoaded"
              />
              <div *ngIf="!imageLoaded" class="image-placeholder"></div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
